<template>
  <Stair :data="data" />
  <br />
  <p>
    A fines del año 1998, el IGP logra revolucionar la meteorología en el Perú
    al implementar un modelo numérico de la atmosféra (PSU/NCAR mesoscale
    model-MM5 instalado en una “Estación de Trabajo” (también conocido como
    Workstation: Compaq Server DS20 que alcanzaba los 4 GFLOPS) para la
    predicción en tiempo real de las condiciones atmosféricas en la región de
    sudamérica; lo cual permitió brindar al público especializado (nacional e
    internacional) un nuevo insumo para el pronóstico de hasta tres días de las
    condiciones atmosféricas (ver Figueroa et al., 1998 para mayor detalles).
    Asimismo, en el aspecto de la investigación, este nueva herramienta numérica
    fue usada para responder algunas preguntas científicas (ver Silva y
    Takahashi (2000)).
  </p>
  <p>
    A inicios del siglo XXI, gracias a un préstamo del Banco Mundial para un
    proyecto relacionado con el Estudio del Fenómeno El Niño, el IGP (junto con
    otras instituciones) logró adquirir estaciones de trabajo de dos tipos con
    una capacidad de cálculo de 4 y 16 GFLOPS (Compaq Server DS20 y ES40). Estos
    equipos fueron de utilidad para continuar con la investigación del clima de
    la atmósfera y océano usando modelos numéricos, así como para mantener una
    base de datos en tiempo real de información oceánica y atmosférica de
    estaciones automáticas. Fueron en estas estaciones de trabajo donde se
    inició el desarrollo de un modelo oceánico lineal de dos dimensiones de la
    onda Kelvin ecuatorial (Mosquera, 2009; Mosquera et al., 2011; Mosquera
    2014), cuyos resultados se usan, hasta la actualidad, como uno de los
    insumos para el diagnóstico y predicción de la dinámica oceánica relacionada
    al fenómeno El Niño.
  </p>
  <p>
    En el 2012, gracias al proyecto de colaboración SPIRALES2012 IRD-IGP y
    recursos propios, el IGP adquiere una arquitectura computacional tipo
    clúster para la implementado modelos numéricos paralelizados; es decir que
    hacen uso del lenguaje de programación en paralelo (interface de
    programación de aplicaciones – OpenMP - para la programación multiproceso de
    memoria compartida y la interfaz de paso de mensajes – MPI - para la
    ejecución de múltiples tareas creados por un único programa) para mejorar la
    eficiencia de cálculo y tener una mejor descripción de la evolución espacial
    y temporal del proceso geofísico.
  </p>
  <p>
    Actualmente, gracias al Convenio de Subvención Nº 101-2014-FONDECYT, el IGP
    cuenta con el “Sistema computacional de Alto Rendimiento para la Simulación
    de Fluidos Geofísicos” el cual está dedicado a suplir la necesidad
    computacional de las actuales investigaciones científicas de alto nivel que
    se desarrollan en el IGP y, por la comunidad científica peruana con fines de
    investigación.
  </p>
</template>
<script>
import Stair from "@/components/common/TimeLine/Stair";

export default {
  components: {
    Stair
  },
  setup() {
    const data = [
      {
        point: 1998,
        subtitle: "4 GFLOPS",
        tag:
          "Modelo Atmosférico de Predicción del Tiempo (PSU/NCAR mesoscale model - MMS)"
      },
      {
        point: 2002,
        subtitle: "16 GFLOPS",
        tag:
          "Modelo oceánico lineal de dos dimensiones de la onda Kelvin ecuatorial (Mosquera, 2009; Mosquera et al., 2011; Mosquera 2014)"
      },
      {
        point: 2009,
        subtitle: "101.7 GFLOPS",
        tag:
          "Experimentos numéricos relacionados con el clima y la dinámica del viento Paracas (Quijano, 2013)"
      },
      {
        point: 2012,
        subtitle: "912 GFLOPS",
        tag:
          "Proyecto SPIRALES2012 IGP-IRD: Serie de experimentos numéricos del océano y atmósfera para estudios del clima en el Perú"
      },
      {
        point: 2014,
        subtitle: "1 TFLOPS",
        tag:
          "Modelo climático de alta resolución (3 km) para estudiar transporte de la humedad de la Amazonía a los Andes y su impacto en la distribución de las precipitaciones (Junquas, 2014). Simulaciones de alta resolución (7 km) para estudiar los efectos de la variabilidad remota sobre el afloramiento costero (Montes et al., 2014)"
      },
      {
        point: 2016,
        subtitle: "19 TFLOPS",
        tag:
          "“Sistema Computacional de Alto Rendimiento para la simulación de Fluídos Geofísicos” pbtenido vía Convenio de Subvención Nº 101-2014-FONDECYT dedicado a suplir la necesidad computacional de las actuales investigaciones científicas de alto nivel que se desarrollan en el IGP y, por la comunidad científica peruana con fines de investifación."
      }
    ];

    return {
      data
    };
  }
};
</script>
